/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { ethers } from "ethers";

import NFTABI from "../config/abis/NFTABI.json";
import { NFT_ADDR, USDT_ADDR } from "../config/contracts";
import { getErc20TokenContract, multicall } from "../utils/contracts";
import { useAddress, useWeb3Context } from "./web3Context";
import useRefresh from "./useRefresh";
import { SUPPORTED_CHAINS } from "../config/chains";

const defaultVal = {
  nftInfo: {
    name: "TrueX",
    maxSupply: 1100,
    totalSupply: 0,
    mintAllowed: false,
    oneTimeLimit: 10,
    mintPrice: ethers.utils.parseUnits("2000", 6),
  },
  accountNftInfo: {
    allowance: false,
    tokenIds: [],
  },
  ethPrice: 0,
  fetchNftData: () => {},
  fetchEthPrice: () => {},
  fetchAccountNftData: () => {},
};

export const NftInfoContext = React.createContext(defaultVal);

export default function useNftInfo() {
  return React.useContext(NftInfoContext);
}

export function NftInfoProvider({ children }) {
  const account = useAddress();
  // const account = "0x9345bbe8f607a8e3b67d4520e99e21d086ad45c2";

  const { chainID } = useWeb3Context();
  const [nftInfo, setNftInfo] = useState(defaultVal.nftInfo);
  const [accountNftInfo, setAccountNftInfo] = useState(defaultVal.accountNftInfo);
  const [ethPrice, setEthPrice] = useState(0);
  const { slowRefresh } = useRefresh();

  async function fetchNftData() {
    try {
      let calls = [
        {
          address: NFT_ADDR[chainID],
          name: "mintAllowed",
        },
        {
          address: NFT_ADDR[chainID],
          name: "oneTimeMintLimit",
        },
        {
          address: NFT_ADDR[chainID],
          name: "mintPrice",
        },
        {
          address: NFT_ADDR[chainID],
          name: "totalSupply",
        },
      ];

      const result = await multicall(NFTABI, calls, chainID);

      setNftInfo({
        ...nftInfo,
        totalSupply: result[3][0].toNumber(),
        mintAllowed: result[0][0],
        oneTimeLimit: result[1][0].toNumber(),
        mintPrice: result[2][0],
      });
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchAccountNftData() {
    try {
      const tokenContract = getErc20TokenContract(USDT_ADDR[chainID], null, chainID);
      const response = await Promise.all([
        axios.post("https://api.thegraph.com/subgraphs/name/sparklingcooldev/trueapex-nft", {
          query: `{
            user(id: "${account.toLowerCase()}") {
              nfts(first: 1000) {
                id
              }
            }
          }`,
        }),
        tokenContract.allowance(account, NFT_ADDR[chainID]),
      ]);
      const tokenIds = response[0].data.data.user.nfts.map((data) => parseInt(data.id));
      setAccountNftInfo({
        allowance: response[1] >= ethers.utils.parseEther("10000"),
        tokenIds,
      });
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (!SUPPORTED_CHAINS.includes(chainID)) return;
    fetchNftData();
  }, [chainID, slowRefresh]);

  useEffect(() => {
    if (!account || !SUPPORTED_CHAINS.includes(chainID)) {
      setAccountNftInfo({
        allowance: false,
        tokenIds: [],
      });
      return;
    }
    fetchAccountNftData();
  }, [account, chainID, slowRefresh]);

  return (
    <NftInfoContext.Provider
      value={{
        nftInfo,
        accountNftInfo,
        ethPrice,
        fetchNftData,
        fetchAccountNftData,
      }}
      children={children}
    />
  );
}
